module.exports = __webpack_public_path__ + "img/uy.6220e4a8.svg";